<template>
    <v-container app :fluid="true" class="pt-0">
        <v-row>
            <v-col cols="6">
                <v-text-field
                    v-model="search"
                    append-icon="fas fa-search"
                    label="Buscar producto"
                    hide-details
                    solo
                    dense
                    class="wost-text-input"
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-btn @click="showCreateCustomer()" 
                    rised 
                    color="indigo" 
                    dark
                    class="float-right wost-btn-new"
                    v-if="verifyPermission('crear_productos')">
                    <v-icon dark left size="12">fas fa-plus</v-icon>Nuevo Producto
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="10" class="pt-0">
                <v-card>
                    <v-data-table
                        class="wost-table"
                        :headers="headers"
                        :items="products"
                        item-key="id"
                        :search="search"
                        height="65vh"
                        @click:row="handleCurrentChange"
                        v-if="verifyPermission('listar_productos')"
                    >
                        <template v-slot:item.product_name="{ item }">
                            {{ item.product_name }}
                            <span :class="'status-' + item.status.toLowerCase()">{{ item.status }}</span>                           
                        </template>
                        <template v-slot:item.action="{ item }">
                            <div class="datatable-cell-wrapper">
                                <!--
                                <a href="#" title="Editar" 
                                    class="btn-actions btn-edit" 
                                    @click="editProduct(item)"
                                    v-if="verifyPermission('actualizar_productos')">
                                    <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                                </a>
                                -->

                                <v-icon v-if="verifyPermission('actualizar_productos')"
                                    color="amber"
                                    size="16"
                                    @click="editProduct(item)">
                                    fas fa-pencil-alt
                                </v-icon>
                                
                                <!--
                                <a v-if="item.status === 'activo' && verifyPermission('inactivar_productos')" 
                                    href="#" title="Inactivar" 
                                    class="btn-actions btn-delete" 
                                    @click="deleteProduct(item, 'inactivar')">
                                    <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                                </a>
                                -->

                                <v-icon v-if="item.status === 'activo' && verifyPermission('inactivar_productos')"
                                    color="grey" 
                                    size="16"
                                    class="ml-2"
                                    @click="deleteProduct(item, 'inactivar')">
                                    fas fa-minus-circle
                                </v-icon>

                                <v-icon v-else-if="item.status.toLowerCase()  === 'inactivo' && verifyPermission('activar_productos')"
                                    color="green darken-1" 
                                    size="16"
                                    class="ml-2"
                                    @click="deleteProduct(item, 'activar')">
                                    fas fa-check-circle
                                </v-icon>

                                <v-icon
                                    color="red darken-1" 
                                    size="16"
                                    class="ml-2"
                                    @click="handleDeleteProduct(item)">
                                    fas fa-trash-alt
                                </v-icon>
                                <!--
                                <a v-else-if="item.status.toLowerCase()  === 'inactivo' && verifyPermission('activar_productos')" 
                                    href="#" title="Activar" 
                                    class="btn-actions btn-delete" 
                                    @click="deleteProduct(item, 'activar')">
                                    <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                                </a>
                                -->

                            </div>
                        </template>                           
                                                        
                    </v-data-table>
                </v-card>
            </v-col>
            <v-col cols="2" class="pt-0">
                <v-card height="72vh" color="#f9f8ff">
                    <v-card-title>
                        Resumen
                    </v-card-title>
                    <v-card-text>
                        <div class="stadistic-item">
                            <span class="stadistic stadistic-item-title">Monto de ventas</span>
                            <span class="stadistic stadistic-item-number">
                                {{ currentStadistic.total_sales | currency('S/') }}
                            </span>
                        </div>
                        <div class="stadistic-item">
                            <span class="stadistic stadistic-item-title">Número de ventas</span>
                            <span class="stadistic stadistic-item-number">
                                {{ currentStadistic.quantity_sales }}
                            </span>
                        </div>
                        <div class="stadistic-item">
                            <span class="stadistic stadistic-item-title">Ventas por semana</span>
                            <span class="stadistic stadistic-item-number">
                                {{ currentStadistic.total_sales_week | currency('S/') }}
                            </span>
                        </div>
                        <div class="stadistic-item">
                            <span class="stadistic stadistic-item-title">Ventas por mes</span>
                            <span class="stadistic stadistic-item-number">
                                {{ currentStadistic.total_sales_month | currency('S/') }}
                            </span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    <print-barcode ref="printBarcode"></print-barcode>

    </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import router from '@/router/index';
import ApiProduct from '../../apis/Product'
import {APIService} from '@/APIService';

import VueBarcode from '@chenfengyuan/vue-barcode';

import printUtil from '@/plugins/print';
import Tools from '../../helpers/Tools';

import PrintBarcode from './PrintBarcode';

const apiService = new APIService();

export default {
    components: {
        PrintBarcode
    },
     data () {
      return {
        drawer: false,
        expanded: [],
        singleExpand: false,
        isCompound: false,
        checkInventory: false,
        titleForm: 'Registro de nuevo producto',
        actionCrud: 'create',
        formProduct: {
            id: null,
            name: null,
            category_id: null,
            unit_id: null,
            cost: null,
            unit_price: null,
            wholesale_price: null,
            preferential_price: null,
            compound: false,
            supplies: [],
            check_inventory: false,
            stock: null,
            minimum_stock: null,
            image: null,
            has_return: false,
            recipe_id: null,
            barcode: null,
            has_barcode: true,
            barcode_saved: null
        },
        categories: [],
        units: [],
        search: '',
        headers: [
          { text: 'Nombre', value: 'product_name', align: 'start', sortable: false, class: 'header-table'},
          { text: 'Marca', value: 'brand_name', align: 'start', sortable: false, class: 'header-table', width: 120 },
          { text: 'Modelo', value: 'pattern_name', align: 'start', sortable: false, class: 'header-table', width: 140 },
          { text: 'Color', value: 'color_name', align: 'start', sortable: false, class: 'header-table', width: 90 },
          { text: 'Und. Medida', value: 'unit_name', align: 'start', sortable: false, class: 'header-table', width: 170 },
          { text: 'SKU', value: 'sku', align: 'start', sortable: false, class: 'header-table', width: 170 },
          { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 },
        ],
        currentRow: null,
        currentStadistic: {
            total_sales: 0,
            quantity_sales: 0,
            total_sales_week: 0,
            total_sales_month: 0
        }
      }
    },
    computed: {
        ...mapState('recipes', [
            'recipes'
        ]),
        ...mapState('products', [
            'products'
        ])
    },
    methods: {
        ...mapActions('general', [
            'setNameSection'
        ]),
        ...mapActions('recipes', [
            'getAllRecipes'
        ]),
        ...mapActions('categories', [
            'getAllCategories'
        ]),
        ...mapActions('units', [
            'getAllUnits'
        ]),
        ...mapActions('products', [
            'getListProducts',
            'setProductSelected'
        ]),
        handleCurrentChange(val) {
            this.currentRow = val;
            this.getStadistic(this.currentRow.id);
        },
        showCreateCustomer() {
            this.setNameSection('Registro de producto');
            router.push('/create-product');
        },
        handleCloseQuantity() {
            this.calculateCost()
        },
        closeDrawer() {
            this.drawer = false
            this.clearForm()
        },
        editProduct(product) {
            this.setNameSection('Actualización de producto');
            this.setProductSelected(product);
            router.push('/update-product');
        },
        deleteProduct(product, status) {
            let label = 'Product 1'
            this.$swal({
                title: "¿Desea confirmar?",
                text: "Confirma que desea " + status + " el producto: " + product.name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if(result.value){
                    if(result.value === true){
                        apiService.inactivateProduct(product.id).then((response) => {
                            let index = this.findProduct(response.data);
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                title: 'ACTUALIZACIÓN DE PRODUCTO',
                                text: 'El estado del producto se actualizó de forma correcta.'
                            });
                            this.products.splice(index, 1, response.data);
                        });
                    }
                }
            })
        },
        getCurrency(amount) {
            let currency = amount.toLocaleString('en-US', { style: 'currency', currency: 'PEN' });
            currency = currency.replace("PEN", "S/");

            return currency;
        },
        getStadistic(product_id = null){
            ApiProduct.getSummary(product_id).then((response) => {
                this.currentStadistic = response.data
            }).catch( function(error){
                console.log('Ocurrió un error')
            })
        },
        findProduct(product) {
            let indexFounded = -1;
            this.products.findIndex(function(element, index){
                if(element.id === product.id){
                    indexFounded = index
                }
            })

            return indexFounded
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        },
        customText(item){
            let text = item.name
            
            return text
        },
        handlePrinBarcode (product) {
            this.$refs.printBarcode.show(product);
        },
        loadData () {
            this.getListProducts();
            this.getStadistic();
        },
        handleDeleteProduct (product) {
            console.log(product);
            this.$swal({
                title: "¿Desea eliminar?",
                text: "Confirma que desea eliminar el producto con sku " + product.sku,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if(result.value){
                    if(result.value === true){
                        ApiProduct.destroyProduct(product).then((response) => {
                            let index = this.findProduct(product);
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                title: 'ELIMINACIÓN DE PRODUCTO',
                                text: 'El producto fué eliminado de forma correcta.'
                            });
                            this.products.splice(index, 1);
                        });
                    }
                }
            })
        }
    },
    created () {
        this.loadData();
    }
}
</script>

<style>

</style>